<section [ngClass]="{ 'remarks-container': isMarginTop }">
  <div class="columns">
    <app-input-submit
      inputText="{{ 'remarks.buttonActionModal' | translate }}"
      type="submit"
      (clickButton)="openRemarksPopUp()"
    ></app-input-submit>
  </div>
</section>

<app-modal
  [isActive]="open"
  (modalState)="open = false"
  [showCloseFooter]="false"
  [enableFooter]="true"
  isLarge="true"
>
  <p class="modal-card-title" modal-title>
    {{ 'remarks.label' | translate }}
  </p>

  <div modal-content>
    <div class="remark-content">
      <div class="form-row">
        <div class="column w-50">
          <app-input-select
            [form]="form"
            inputName="remarkType"
            [translate]="true"
            [values]="REMARKS_TYPES"
            label="{{ 'remarks.input-select-type-label' | translate }}"
            placeholder="{{ 'remarks.input-select-type-placeholder' | translate }}"
          ></app-input-select>
        </div>
        <div class="column control has-icons-right w-50">
          <input
            [class.is-tall]="tall"
            [(ngModel)]="inputValue"
            [ngModelOptions]="{ standalone: true }"
            (keydown.enter)="addRemark()"
            class="input"
            type="text"
            id="remarkAddInput"
            autocomplete="off"
            [placeholder]="'remarks.input-placeholder' | translate"
            (blur)="addRemark()"
            (keypress)="handleKeypress($event.key)"
          />
          <span class="icon plus is-small is-right has-text-grey has-events" (click)="addRemark()">
            <em class="mdi mdi-plus is-size-4 has-pointer-cursor"></em>
          </span>
        </div>
      </div>

      <div class="remarks-list">
        <div class="columns flex-column w-50" [formGroup]="form">
          <div>
            <h4 class="remark-type-title">
              {{ 'remarks.generic-type-label' | translate }}
            </h4>
          </div>
          <div
            class="column is-12 field is-grouped column-align is-grouped-multiline"
            formArrayName="genericRemarks"
          >
            <div class="control max-100" *ngFor="let tag of genericRemarksList; let i = index">
              <div class="tags has-addons">
                <span class="tag is-light"> {{ tag.text }}</span>
                <a class="tag is-delete" (click)="deleteGenericRemark(i)"></a>
              </div>
            </div>
          </div>
        </div>

        <div class="columns flex-column w-50" [formGroup]="form">
          <div>
            <h4 class="remark-type-title">
              {{ 'remarks.historic-type-label' | translate }}
            </h4>
          </div>
          <div
            class="column is-12 field is-grouped column-align is-grouped-multiline"
            formArrayName="historicRemarks"
          >
            <div class="control max-100" *ngFor="let tag of historicRemarksList; let i = index">
              <div class="tags has-addons">
                <span class="tag is-light"> {{ tag.text }}</span>
                <a class="tag is-delete" (click)="deleteHistoricRemark(i)"></a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div modal-footer>
    <div class="columns">
      <app-input-submit
        class="column is-3 is-offset-9"
        inputText="{{ 'remarks.buttonActionSave' | translate }}"
        type="submit"
        (clickButton)="saveRemarks()"
        [disabled]="!isValidRemarks()"
        [isLoading]="loading"
      ></app-input-submit>
    </div>
  </div>
</app-modal>
